var _rect, _rect2, _path, _path2, _path3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoursePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#f8fafc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 1040,
    height: 640,
    rx: 48,
    fill: "#ffffff",
    stroke: "#cbd5e1",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 280h640",
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280 400h640",
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280 520h260",
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 16
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 720,
    fill: "#94a3b8",
    fontFamily: "Inter,system-ui,Arial,sans-serif",
    fontSize: 64,
    textAnchor: "middle"
  }, "No Image")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePlaceholder);
export default __webpack_public_path__ + "static/media/course-placeholder.7ff0b627454a5d95dbfffebd21a38207.svg";
export { ForwardRef as ReactComponent };